@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.resource {
  padding: spacers.getSpacer(s) spacers.getSpacer(s) spacers.getSpacer(l);
  border-width: 6px;
  border-style: solid;

  @media (min-width: map.get($grid-breakpoints, md)) {
    padding-left: spacers.getSpacer(m);
    padding-right: spacers.getSpacer(m);
  }

  @media (min-width: map.get($grid-breakpoints, lg)) {
    padding-right: spacers.getSpacer(l);
  }

  &--none {
    padding: unset;
    border-width: unset;
    border-style: unset;
  }

  &--single {
    @media (min-width: map.get($grid-breakpoints, md)) {
      display: flex;
    }

    @media print {
      display: flex;
    }
  }

  &--normal {
    border-color: palette.$neutral200;
  }

  &--highlight {
    border-color: palette.$neutral50;
    background-color: palette.$neutral50;
  }

  &--critical {
    border-color: palette.$banana50;
    background-color: palette.$banana50;
  }

  &--criticalHighlight {
    border-color: palette.$cherry500;
  }
}
